module.exports = __webpack_public_path__ + "img/HU22196796.f1d11823.png";